import { useEffect, useState } from "react"
import { Box, Badge, Chip, Paper, Stack, Typography } from "@mui/material"
import SimilarSkill from "./SimilarSkill"
import useTranslationSharie from "../hooks/Language/useTranslation"
import { useApiService } from "../hooks/Api/useApiService"

const CombinedSkills = ({ skills = [] }) => {
  const [selected_skill, setSelectedSkills] = useState(null) // Store similar skills from API
  const [a_b, setAB] = useState({
    a: null,
    b: null,
  })
  const { postData } = useApiService()
  const t = useTranslationSharie()

  useEffect(() => {
    if (a_b.a && a_b.b) {
      postData("ai/combinedskills", {
        skillNameA: a_b.a.skill.name,
        skillNameB: a_b.b.skill.name,
      }).then((data) => {
        if (data && data.skill) {
          setSelectedSkills(data.skill)
        } else {
          setSelectedSkills(null)
        }
      })
    }
  }, [a_b])

  const handleSkillClick = (skill) => {
    setAB((prevState) => {
      // If this skill is already selected in 'a'
      if (prevState.a && prevState.a.skill?.name === skill.name) {
        return { ...prevState, a: null }
      }

      // If this skill is already selected in 'b'
      if (prevState.b && prevState.b.skill?.name === skill.name) {
        return { ...prevState, b: null }
      }

      // Otherwise, select it
      if (!prevState.a) {
        return { ...prevState, a: { skill } }
      } else if (!prevState.b) {
        return { ...prevState, b: { skill } }
      }

      // If both selected, replace 'b'
      return { ...prevState, b: { skill } }
    })
  }

  return (
    <Paper
      elevation={4}
      sx={{
        p: 3,
        borderRadius: "0.8rem",
        width: "100%", // Set full width of the parent container
        mx: "auto", // Center horizontally
        mt: 4,
        m: 4,
        overflow: "hidden", // Prevents overflow if content exceeds width
        position: "relative", // Needed for the minimize icon to position correctly
      }}
    >
      <Stack alignItems={"center"} direction='row' spacing={1} flexWrap='wrap'>
        <Typography variant='body2' color='text.secondary' sx={{ padding: "1rem" }}>
          {t("Combined Skills")}
        </Typography>
        {skills.map((skill) => (
          <Badge
            key={skill.name}
            badgeContent={skill.likes_count} // Number of likes
            color='error' // Red badge color
            overlap='circular' // Keeps badge within chip
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "12px",
                fontWeight: "bold",
                minWidth: "20px",
                height: "20px",
                borderRadius: "50%",
                padding: "0 6px",
                marginLeft: "15px",
              },
            }}
          >
            <Chip
              label={skill.name}
              color={
                (a_b.a && a_b.a.skill?.name === skill.name) ||
                (a_b.b && a_b.b.skill?.name === skill.name)
                  ? "primary"
                  : "default"
              }
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                p: 0.5,
                cursor: "pointer",
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() => handleSkillClick(skill)}
            />
          </Badge>
        ))}
      </Stack>

      {selected_skill && (
        <Box sx={{ mt: 2 }}>
          <SimilarSkill
            skill={selected_skill.name ? selected_skill : { name: selected_skill }}
            key={selected_skill?.name}
          />
        </Box>
      )}
    </Paper>
  )
}

export default CombinedSkills
